/**
 * After a deploy, a tab opened earlier can ask for code-split files that no
 * longer exist. Reloading picks up the new build. Guarded so a genuinely
 * broken deploy can't put the page in a reload loop.
 */
const KEY = "napkin_chunk_reload_at";
const WINDOW_MS = 30_000;

export function isChunkLoadError(err: unknown): boolean {
  const e = err as { name?: string; message?: string } | null;
  return (
    e?.name === "ChunkLoadError" ||
    /Loading (CSS )?chunk [\w-]+ failed/i.test(e?.message || "")
  );
}

/** Reload once; returns false if we already tried very recently */
export function reloadForNewVersion(): boolean {
  try {
    const last = Number(sessionStorage.getItem(KEY) || 0);
    if (Date.now() - last < WINDOW_MS) return false;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    // storage blocked: still worth one reload
  }
  window.location.reload();
  return true;
}
